import { GlIcon, GlLink, GlDisclosureDropdown, GlDisclosureDropdownItem, GlTooltipDirective, GlDropdownDivider } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import TooltipOnTruncate from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/directives/tooltip_on_truncate.js?vue3';
import toast from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/plugins/global_toast.js?vue3';
import { visitUrl } from '~/lib/utils/url_utility';
import { createBranchMRApiPathHelper } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/utils.js?vue3';
export default {
    name: 'WorkItemDevelopmentBranchItem',
    components: {
        GlIcon,
        GlLink,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlDropdownDivider
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        TooltipOnTruncate
    },
    props: {
        itemContent: {
            type: Object,
            required: true
        },
        canCreateMergeRequest: {
            type: Boolean,
            required: false,
            default: true
        },
        workItemFullPath: {
            type: String,
            required: true
        },
        workItemIid: {
            type: String,
            required: true
        }
    },
    computed: {
        branchName () {
            return this.itemContent?.name;
        },
        branchComparePath () {
            return this.itemContent?.comparePath;
        },
        iconTooltip () {
            return __('Branch');
        }
    },
    methods: {
        copyToClipboard (text, message) {
            toast(message);
            this.closeDropdown();
        },
        closeDropdown () {
            this.$refs.branchMoreActions.close();
        },
        createMergeRequest () {
            const path = createBranchMRApiPathHelper.createMR({
                fullPath: this.workItemFullPath,
                workItemIid: this.workItemIid,
                sourceBranch: this.branchName
            });
            visitUrl(path);
        }
    }
};
